import api from './baseAPI';

export const notificationAPI = {
  getMyForTeacher: (params?: { page?: number; limit?: number; onlyUnread?: boolean; }) => {
    return api.get('/notifications/me-teacher', { params }).then(r => r.data);
  },
  getMyForUser: (params?: { page?: number; limit?: number; onlyUnread?: boolean; }) => {
    return api.get('/notifications/me', { params }).then(r => r.data);
  },
  markReadTeacher: (notificationId: number | string) => {
    return api.put(`/notifications/${notificationId}/read-teacher`).then(r => r.data);
  },
  markReadUser: (notificationId: number | string) => {
    return api.put(`/notifications/${notificationId}/read`).then(r => r.data);
  },
  // 전체공지 전송
  sendToAllUsers: (data: { title: string; message: string; titleEn: string; messageEn: string }) => {
    return api.post('/notifications/send-to-all', data).then(r => r.data);
  }
}; 